var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPullingAndUnassigned = function SvgPullingAndUnassigned(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 145 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M92.7396 36.39C95.8496 35.89 101.66 36.19 104.67 41.31C107.07 45.39 112.35 53.04 109.58 57.29C106.55 61.94 96.3596 57.29 85.9396 60.6C77.1996 63.38 74.5896 79.52 71.2496 78.25C64.9896 75.87 63.3096 70.87 67.0496 65.41C68.9696 62.6 71.8796 58.16 74.5496 55.58C78.9096 51.35 88.0496 48.28 96.7296 49.34",
    stroke: "#212124",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M93.4219 14.0399L94.2519 12.8799",
    stroke: "#212124",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M65.0728 43.9798C65.0728 43.9798 58.4428 35.3498 51.8428 36.2198C46.8028 36.8798 45.3228 41.1198 43.3828 43.5198",
    stroke: "#212124",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M71.825 71.24C70.145 73.6 67.525 76.23 70.375 77.88",
    stroke: "#212124",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M69.1187 68.53C67.5587 70.26 65.2187 72.91 66.5987 75.12",
    stroke: "#212124",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M65.9459 67.3198C65.9459 67.3198 57.3859 69.4298 46.2659 63.0898C45.4059 69.6398 40.0859 84.5898 40.0859 84.5898",
    stroke: "#212124",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M110.238 55.62C117.968 62.73 123.288 72.53 124.608 83.77C127.548 108.72 109.698 131.34 84.7477 134.28C59.7977 137.22 37.1777 119.37 34.2377 94.42C34.2377 94.42 20.5577 94.31 18.0177 94.27C15.4777 94.23 13.2477 93.27 13.2977 90.69C13.3377 88.41 15.5077 87.84 16.7577 87.55C18.0077 87.26 24.0277 86.89 25.4577 83.56C28.4077 76.67 28.2077 65.54 30.9977 54.71C33.3277 45.66 38.3277 42.09 49.7877 44.59C67.6477 48.48 74.4377 39.32 87.0677 18.37C85.6877 17.64 82.6277 16.03 84.4877 13.28C86.3477 10.53 89.0977 13.39 91.0277 10.9C93.6977 7.45997 98.6477 5.57997 104.138 9.04997C110.718 13.21 106.678 20.51 105.548 23.99C104.628 26.83 100.208 37.77 100.208 37.77",
    stroke: "#212124",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M114.968 60.69C124.818 59.21 131.758 60.24 133.648 64.14C137.668 72.44 117.288 90.62 88.1384 104.75C58.9784 118.88 32.0884 123.6 28.0684 115.3C26.3284 111.71 29.1584 106.27 35.2984 100.1",
    stroke: "#212124",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#9874FF",
    d: "M29.8653 43.7199L33.1253 31.6399L43.6253 34.7099L35.9553 26.1199L48.1753 24.6399L35.5253 21.2799L43.5253 11.0699L32.6453 17.1099L27.2753 4.40991L24.4053 17.5399L10.6953 15.5299L19.0353 24.0599L12.3753 36.8099L23.3453 31.3999L29.8653 43.7199Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#9874FF",
    d: "M127.849 34.59L125.729 39.86L124.649 35.34L119.969 36.13L123.199 33.1L120.879 29.03L124.529 29.94L124.409 25.88L127.099 29.16L129.429 25.01L129.969 29.7L134.819 30.19L130.749 32.14L132.119 36.33L127.849 34.59Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#9874FF",
    d: "M123.047 130.27L123.287 126.86L120.537 130.44L117.517 128.13L118.667 131.92L115.117 131.75L118.437 133.73L115.497 135.95L119.617 135.18L121.277 139.59L122.107 135.18L125.187 136.51L123.077 132.69L127.287 131.75L123.047 130.27Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M135.227 103.73V114.1",
    stroke: "#13C2C2",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M140.483 108.91H129.953",
    stroke: "#13C2C2",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4375 58.45V70.89",
    stroke: "#13C2C2",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3356 64.6699H4.51562",
    stroke: "#13C2C2",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPullingAndUnassigned);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "pullingAndUnassigned.f67632a22c134216c0e869a18a65d537.svg";